module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"busqueda_materiales":"Búsqueda de materiales...","busqueda_materiales_biblioteca":"Elige un producto real para su evaluación..."}}')
  delete Component.options._Ctor
}
